import React from 'react'
import PageTitle from '../components/common/pageTitle'
import ContactInfo from '../components/sections/contactInfo'
import ContactThanks from '../components/sections/contactThanks'
import { ScrollRestoration } from 'react-router-dom'

const Thanks = () => {
    return (
        <>
            <PageTitle pageName="Thanks" />
          
            <ContactThanks />
            <ScrollRestoration />
        </>
    )
}

export default Thanks